import React from "react";
import { SignedIn, SignedOut, SignIn, UserButton } from "@clerk/clerk-react";
import signInPageBG from "./../../Images/signInPageBG.jpg";
import helxonLogo from "./../../Images/helxonLogo.svg";
import vorxocLogo from "./../../Images/vorxocWhite.svg";
import vorxocLogoGreen from "./../../Images/vorxocGreen.svg";
import "./auth.scss";

// Fixed appearance for SignIn - completely overrides global ClerkThemeProvider settings
// This ensures SignInPage is NOT affected by theme changes
const SIGNIN_APPEARANCE = {
  // Override ALL global variables with fixed values
  variables: {
    colorPrimary: "#39ff14",
    colorBackground: "transparent",
    colorInputBackground: "rgba(255,255,255,0.15)",
    colorInputText: "#ffffff",
    colorText: "#ffffff",
    colorTextSecondary: "#e5e7eb",
    colorTextOnPrimaryBackground: "#000000",
    colorDanger: "#ef4444",
    colorSuccess: "#10b981",
    colorWarning: "#f59e0b",
    borderRadius: "8px",
    fontFamily: "'Inter', system-ui, -apple-system, sans-serif",
  },
  // Use explicit inline styles + CSS classes to completely override global theme
  elements: {
    // Root and card - force transparent
    rootBox: {
      backgroundColor: "transparent",
    },
    card: {
      backgroundColor: "transparent",
      boxShadow: "none",
      border: "none",
    },
    // Main content
    main: {
      backgroundColor: "transparent",
    },
    // Header - use CSS classes
    headerTitle: "auth__signin-title",
    headerSubtitle: "auth__signin-subtitle",
    // Social buttons - use CSS classes
    socialButtonsBlockButton: "auth__social-button",
    socialButtonsBlockButtonText: "auth__social-text",
    socialButtonsProviderIcon: "auth__social-icon",
    // Form elements - use CSS classes
    formFieldLabel: "auth__form-label",
    formFieldLabelText: "auth__form-label-text",
    formFieldInput: "auth__form-input",
    formButtonPrimary: "auth__form-button",
    formFieldInputShowPasswordButton: "auth__show-password",
    // Divider - use CSS classes
    dividerLine: "auth__divider",
    dividerText: "auth__divider-text",
    // Footer - force transparent and override global styles
    footer: {
      backgroundColor: "transparent",
      borderTop: "none",
    },
    footerAction: {
      backgroundColor: "transparent",
    },
    footerActionText: {
      color: "#e5e7eb",
    },
    footerActionLink: {
      color: "#39ff14",
    },
  },
};

export default function SignInPage() {
  return (
    <div
      className="auth"
      style={{ backgroundImage: `url(${signInPageBG})` }}
      aria-label="VORXOC Sign In"
    >
      <SignedOut>
        <div className="auth__center">
          <div className="auth__container" role="dialog" aria-modal="true">
            <div className="auth__brand-header">
              <div className="auth__brand-logo">
                <img src={vorxocLogoGreen} alt="VORXOC" className="green-logo" />
                <img src={vorxocLogo} alt="VORXOC" className="white-logo" />
              </div>
            </div>

            <div className="auth__signin-wrapper">
              <SignIn routing="hash" appearance={SIGNIN_APPEARANCE} />
            </div>

            <div className="auth__footer">
              <span>Powered by</span>
              <img src={helxonLogo} alt="Helxon" className="auth__footer-logo" />
            </div>
          </div>
        </div>
      </SignedOut>

      <SignedIn>
        <div className="auth__center">
          <div className="auth__container auth__container--success">
            <div className="auth__success-card">
              <div className="auth__success-icon" aria-hidden="true">
                <svg width="56" height="56" viewBox="0 0 48 48" fill="none">
                  <circle cx="24" cy="24" r="24" fill="#10B981" />
                  <path
                    d="M17.5 24.5l5.2 5.2 10-10"
                    stroke="white"
                    strokeWidth="2.6"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <h2 className="auth__success-title">Welcome to VORXOC</h2>
              <p className="auth__success-sub">Security Operation Center</p>
              <UserButton afterSignOutUrl="/" />
            </div>
          </div>
        </div>
      </SignedIn>
    </div>
  );
}